import * as React from "react";
const SvgSadRedFace = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 7.998, r: 6, fill: "#f3676b", style: {
  fill: "#f3676b",
  fill: "color(display-p3 .9529 .4039 .4196)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", d: "M6 6.5v1m4-1v1m-4 3a4.47 4.47 0 0 1 4 0v0", style: {
  stroke: "#fff",
  strokeOpacity: 1
} }));
export default SvgSadRedFace;
